var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinistryBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 17.4999V11.0833",
    stroke: "#192C6D",
    strokeWidth: 0.981818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 17.4999V11.0833",
    stroke: "#192C6D",
    strokeWidth: 0.981818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.4999V11.0833",
    stroke: "#192C6D",
    strokeWidth: 0.981818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 17.4999V11.0833",
    stroke: "#192C6D",
    strokeWidth: 0.981818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 17.4999V11.0833",
    stroke: "#192C6D",
    strokeWidth: 0.981818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.79175C12.7594 8.79175 13.375 8.17614 13.375 7.41675C13.375 6.65736 12.7594 6.04175 12 6.04175C11.2406 6.04175 10.625 6.65736 10.625 7.41675C10.625 8.17614 11.2406 8.79175 12 8.79175Z",
    stroke: "#192C6D",
    strokeWidth: 0.981818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3391 2.97126L20.5891 6.27124C20.9099 6.39957 21.1666 6.78456 21.1666 7.12373V10.1671C21.1666 10.6712 20.7541 11.0837 20.2499 11.0837H3.74992C3.24575 11.0837 2.83325 10.6712 2.83325 10.1671V7.12373C2.83325 6.78456 3.08992 6.39957 3.41076 6.27124L11.6608 2.97126C11.8441 2.89793 12.1557 2.89793 12.3391 2.97126Z",
    stroke: "#5679EC",
    strokeWidth: 0.981818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1666 21.1669H2.83325V18.4169C2.83325 17.9127 3.24575 17.5002 3.74992 17.5002H20.2499C20.7541 17.5002 21.1666 17.9127 21.1666 18.4169V21.1669Z",
    stroke: "#5679EC",
    strokeWidth: 0.981818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91675 21.1665H22.0834",
    stroke: "#5679EC",
    strokeWidth: 0.981818,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistryBlue);
export default __webpack_public_path__ + "static/media/ministry-blue.c93f3350.svg";
export { ForwardRef as ReactComponent };